import type { ChatSettingsTranslation } from './types';

export const chatSettingsHi: ChatSettingsTranslation = {
  open: 'चैट सेटिंग्स',
  openLabel: '{{name}} की चैट सेटिंग्स',
  title: '{{name}} की चैट सेटिंग्स',
  description:
    'चैट आपकी वेबसाइट पर कैसे दिखे और ग्राहक उसमें क्या कर सकें। बदलाव एक मिनट में वेबसाइटों तक पहुँचते हैं।',
  saved: '{{name}} की चैट सेटिंग्स सहेजी गईं।',
  save: 'सेटिंग्स सहेजें',
  loading: 'चैट सेटिंग्स लोड हो रही हैं',
  invalidNumber: '{{min}} से {{max}} तक की कोई पूर्ण संख्या लिखें।',
  languages: { en: 'अंग्रेज़ी', ar: 'अरबी', hi: 'हिन्दी', ur: 'उर्दू' },
  layout: {
    legend: 'चैट कहाँ दिखे',
    bubble: 'तैरता बटन',
    bubbleHint: 'कोने में एक गोल बटन चैट खोलता है।',
    panel: 'साइड पैनल',
    panelHint: 'बटन पेज के एक किनारे पर चैट खोलता है।',
    inline: 'पेज के अंदर',
    inlineHint: 'चैट आपके पेज के उस हिस्से में रहती है जिसे आप चुनें।',
    fullpage: 'पूरा पेज',
    fullpageHint: 'चैट पूरा पेज भरती है, अपने अलग मदद पेज के लिए।',
    side: 'बटन का कोना',
    right: 'नीचे दाएँ',
    left: 'नीचे बाएँ',
    note: 'फ़ोन पर तैरता बटन और साइड पैनल चैट को पूरी स्क्रीन पर खोलते हैं।',
  },
  files: {
    legend: 'फ़ाइलें',
    enabled: 'ग्राहक फ़ाइलें भेज सकते हैं',
    enabledHint:
      'हर फ़ाइल की पहले वायरस जाँच होती है। सर्वर पर वायरस स्कैनर न हो, तो चैट में फ़ाइलें नहीं भेजी जा सकतीं।',
    types: 'फ़ाइलों के प्रकार',
    png: 'PNG तस्वीरें',
    jpeg: 'JPEG फ़ोटो',
    webp: 'WebP तस्वीरें',
    gif: 'GIF तस्वीरें',
    pdf: 'PDF दस्तावेज़',
    typesRequired: 'कम से कम एक तरह की फ़ाइल चुनें।',
    maxMegabytes: 'सबसे बड़ी फ़ाइल (MB)',
    maxMegabytesHint: '1 से 10 तक।',
    maxFiles: 'एक संदेश में फ़ाइलें',
    maxFilesHint: '1 से 5 तक।',
  },
  help: {
    legend: 'बातचीत से पहले मदद',
    search: 'ग्राहक आपके सार्वजनिक मदद लेख खोज सकते हैं',
    suggestions: 'सुझाए गए सवाल',
    suggestionsHint: '6 तक, चैट की पहली स्क्रीन पर। अंग्रेज़ी ज़रूरी है; ख़ाली भाषा में अंग्रेज़ी दिखती है।',
    question: 'सवाल {{number}}',
    add: 'सवाल जोड़ें',
    remove: 'सवाल {{number}} हटाएँ',
    required: 'सवाल {{number}} अंग्रेज़ी में लिखें।',
  },
  deletion: {
    label: 'ग्राहक इतने समय तक संदेश मिटा सकते हैं (मिनट)',
    hint: '0 से 60 तक। 0 से मिटाना बंद हो जाता है।',
  },
  emails: {
    label: 'साइन इन किए ग्राहकों को उनकी बातचीत के बारे में ईमेल का विकल्प दें',
    hint: 'बातचीत बंद होने पर एक कॉपी, और जवाब के इंतज़ार में होने पर सूचना। ग्राहक चुनते हैं, और हर ईमेल में उन्हें रोकने का लिंक होता है।',
  },
};
